<template>
  <li class="layout/width:100%">
    <a
      class="link/focus"
      data-gtm="clicks on artist"
      :href="`/artists/${id}`"
      >
      <div
        class="
          layout/flex:column
          layout/width:100%
        "
        >
        <h3
          class="typography"
          v-html="name"
        />
        <p
          v-if="displayDate !== ''"
          class="
            $typography/scale:down
            $typography/weight:regular
            typography
            typography/truncate:4
          "
          v-html="displayDate"
        />
        <p
          v-if="exhibitionCount > 0"
          class="
            $color/alpha:54%
            $typography/scale:down
            $typography/weight:regular
            typography
          "
          v-html="i18n.t('collection__objects__list__exhibition-count', exhibitionCount)"
        />
        <p
          v-if="objectCount > 0"
          class="
            $color/alpha:54%
            $typography/scale:down
            $typography/weight:regular
            typography
          "
          v-html="i18n.t('collection__objects__list__works-count', objectCount)"
        />
      </div>
    </a>
  </li>
</template>

<script>
  import i18n from 'Utils/i18n.js';

  export default {
    props: {
      displayDate: { type: String, required: true },
      exhibitionCount: { type: Number, required: true },
      id: { type: Number, required: true },
      name: { type: String, required: true },
      objectCount: { type: Number, required: true },
    },

    data() {
      return {
        i18n: new i18n(),
      };
    },
  };
</script>
